import styled from 'styled-components';

import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { styledGetCustomComponentProperty } from '../../../../../../helpers';
import { fontStyle } from '../../../../../../theme/helpers/fontStyle';
import { getInputBorderColor } from '../../../../Autocomplete/Autocomplete.styles';
import { InputStatus } from '../../../../common/helpers/getFinalFieldState.types';

export const $Container = styled.div<{
  $isFocused: boolean;
  $status?: InputStatus;
  $isSmall?: boolean;
}>`
  display: flex;
  width: 100%;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  border: 1px solid
    ${({ theme, $isFocused, $status }) => {
      return getInputBorderColor(
        {
          isFocused: $isFocused,
          selectProps: { status: $status },
        },
        theme,
        theme.colors.default,
      );
    }};

  height: ${({ $isSmall }) => {
    if ($isSmall) {
      return '32px';
    }

    return styledGetCustomComponentProperty({
      componentName: SUPPORTED_COMPONENTS.DEFAULT_INPUTS,
      property: SUPPORTED_PROPERTIES.HEIGHT,
    });
  }};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    boxshadow: 0px 0px 4px
      ${({ theme, $isFocused, $status }) =>
        rgba(
          getInputBorderColor(
            {
              isFocused: $isFocused,
              selectProps: { status: $status },
            },
            theme,
            theme.colors.primary,
          ),
          0.4,
        )};
  }
`;

export const $Input = styled.input`
  overflow: visible;
  height: 100%;
  box-sizing: border-box;
  padding: 0 ${spacing('sm')};
  border: 1px solid ${({ theme }) => theme.colors.default};
  margin: 0;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-family: inherit;
  ${fontStyle('sm')};

  outline: none;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.primary};
  }
`;
